<template>
  <div>
      <h1 style="display: none">Carbono Neutral: Contactanos para conseguirlo</h1>
      <div class="md-layout md-head-water carbononeutral-header mt-2" >
            <div class="md-layout-item md-small-size-100 md-medium-size-60" >
                <h1 class="calcHead head-sellos" style="margin-bottom: 2px !important; margin-top: 15px !important;color: #707070;"> 
                    ¿CÓMO CERTIFICARSE
                </h1>
                <h1 class="calcHead head-sellos" style="margin-top: 2px !important;">CARBONO NEUTRAL?</h1>
                <div class="md-small-hide">
                    <p class="headPara">Nuestro programa de certificación, permite a las organizaciones tomar medidas concretas y efectivas para reducir sus impactos en el cambio climático.</p>
                    <p class="headPara">
                    Estas certificaciones pueden ser obtenidas por grandes compañías o por pymes. El objetivo de estas certificaciones es el de contribuir directamente con el medio ambiente y fomentar una economía baja en carbono. 
                    </p>
                </div>
            </div>
        
            <div class="md-layout-item right-side-head md-small-size-100 md-size-40" style="position: relative;">
                <img src="@/assets/CARBON-NEUTRAL-PRODUCT.png" alt="Producto de huella de carbono neutral" srcset="" class="head-right-image-seil" >
            </div>

            <div class="md-layout-item md-medium-hide md-small-size-100">
                <div>
                    <p class="headPara">Nuestro programa de certificación, permite a las organizaciones tomar medidas concretas y efectivas para reducir sus impactos en el cambio climático.</p>
                    <p class="headPara">
                    Estas certificaciones pueden ser obtenidas por grandes compañías o por pymes. El objetivo de estas certificaciones es el de contribuir directamente con el medio ambiente y fomentar una economía baja en carbono. 
                    </p>
                </div>
            </div>
        </div>
        <Three  />
        <CuadroNeutral />
        <secondSection />
  </div>
</template>

<script>
import Three from '@/components/Three.vue'
import CuadroNeutral from '@/components/Cuadroneutral.vue'
import secondSection from '@/components/secondSection.vue'
export default {
    name: 'carbon-Neutral',
    metaInfo: {
        title: 'Carbono Neutral | Neutraliza tu impacto en el cambio climatico',
        meta: [
            { name: 'description', content: 'Neutraliza tu Huella de Carbono con Green Solutions | Asesoría y Medición Ambiental. Ayudamos a empresas a reducir emisiones y lograr la neutralidad en carbono. Cumple con los ODS y construye un futuro sostenible. Contáctanos para tomar acciones contra el cambio climático y mejorar tu impacto ambiental.' }
        ]
    },
    components: {secondSection, Three, CuadroNeutral}
}
</script>

<style>
.carbononeutral-header {
    padding-bottom: 12vw;
    text-align: justify;
}

.headPara {
    text-align: justify;
}

</style>